<div class="variable-spend-form">
  <form [formGroup]="formGroup">
    <div>
      <glxy-form-field appearance="outline" [prefixText]="'$ '" [suffixText]="displayFrequency">
        <glxy-label>{{ inputLabelKey | translate }}</glxy-label>
        <input
          matInput
          type="number"
          (change)="changeSpendAmount($event)"
          (keyup)="onKeyUpSpendAmount($event)"
          formControlName="spendAmount"
          class="right-align"
          onwheel="this.blur()"
        />
        <glxy-hint>Minimum {{ minSpendAmount | currencyWithoutUSD : currencyCode : 'en-US' }}</glxy-hint>
      </glxy-form-field>
    </div>

    <div *ngIf="managementFee && managementFee.amountType === FeeAmountType.FEE_AMOUNT_TYPE_PERCENTAGE">
      {{ managementFee.amount }}% {{ managementFeeLabel | translate }}
      <ng-container *ngIf="calculatedManagementFeeAmount$$ | async as calculatedAmount">
        = {{ calculatedAmount | currencyWithoutUSD : currencyCode : 'en-US' }}
      </ng-container>
    </div>

    <div *ngIf="managementFee && managementFee.amountType === FeeAmountType.FEE_AMOUNT_TYPE_FIXED">
      <ng-container *ngIf="calculatedManagementFeeAmount$$ | async as calculatedAmount">
        {{ calculatedAmount | currencyWithoutUSD : currencyCode : 'en-US' }} Management fee
      </ng-container>
    </div>

    <br />

    <div class="total">
      <ng-container *ngIf="calculatedManagementFeeAmount$$ | async as calculatedAmount">
        Total:
        {{
          formGroup.controls['spendAmount'].value * 100 + calculatedAmount | currencyWithoutUSD : currencyCode : 'en-US'
        }}
        {{ displayFrequency }}
        <ng-container *ngIf="displaySetupFee && setupFee > 0">
          <p class="setup-fee">
            +
            {{ setupFee | currencyWithoutUSD : currencyCode : 'en-US' }} Setup fee
          </p>
        </ng-container>
      </ng-container>
    </div>

    <ng-container *ngIf="displayAddNote">
      <div *ngIf="!addingNote" class="add-note-button" (click)="addNote()">
        <a>+ {{ addNoteKey | translate }}</a>
      </div>

      <div *ngIf="addingNote">
        <glxy-form-field class="note-box">
          <glxy-label>{{ noteLabelKey | translate }}</glxy-label>
          <textarea
            matInput
            #requesterNote
            matTextareaAutosize
            matAutosizeMinRows="3"
            [maxlength]="noteMaxLength"
            [placeholder]="'Enter a note here'"
            formControlName="requesterNote"
            (change)="changeRequesterNote($event)"
          ></textarea>
          <glxy-hint align="end">{{ requesterNote.value.length }} / {{ noteMaxLength }}</glxy-hint>
        </glxy-form-field>
      </div>
    </ng-container>
  </form>
</div>
